import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

const TOKEN_KEY = "fpl_totem_token";

export const auth = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  setToken(t) {
    localStorage.setItem(TOKEN_KEY, t);
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
  },
  isLoggedIn() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
};

api.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      auth.clear();
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// --- helpers ---------------------------------------------------------

export const fdrClass = (n) => {
  if (n === 1) return "fdr-1";
  if (n === 2) return "fdr-2";
  if (n === 3) return "fdr-3";
  if (n === 4) return "fdr-4";
  if (n === 5) return "fdr-5";
  return "bg-totem-surfaceHigh text-totem-textDim";
};

export const teamBadgeUrl = (teamCode, size = 50) =>
  teamCode
    ? `https://resources.premierleague.com/premierleague/badges/${size}/t${teamCode}.png`
    : null;

export const playerPhotoUrl = (photoCode) =>
  photoCode
    ? `https://resources.premierleague.com/premierleague/photos/players/110x140/p${photoCode}.png`
    : null;

export const formatKickoff = (iso) => {
  if (!iso) return "TBC";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "TBC";
  }
};

export const countdownParts = (iso) => {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const now = Date.now();
  let diff = Math.max(0, target - now);
  const days = Math.floor(diff / (24 * 3600 * 1000));
  diff -= days * 24 * 3600 * 1000;
  const hours = Math.floor(diff / (3600 * 1000));
  diff -= hours * 3600 * 1000;
  const minutes = Math.floor(diff / (60 * 1000));
  diff -= minutes * 60 * 1000;
  const seconds = Math.floor(diff / 1000);
  return { days, hours, minutes, seconds, expired: target - Date.now() <= 0 };
};

export const formatRank = (n) => {
  if (n === null || n === undefined) return "—";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(".0", "") + "k";
  return String(n);
};
